<template>
  <div class="w-100">
    <form v-show="canWrite" @submit.prevent="saveForm">
      <h1 class="mb-3">Reinigung</h1>

      <div class="row">
        <date-input v-model="actionDate" input-id="actionDate"></date-input>
        <time-input v-model="actionTime" input-id="actionTime"></time-input>

        <div class="input-group form-check mb-3">
          <input v-model="systemCleaned" type="checkbox" class="form-check" id="systemCleaned">
          <label class="form-check-label ml-2" for="systemCleaned">Anlage gereinigt</label>
        </div>
      </div>
    </form>

    <workflow-notes :note-data="noteData" :can-write="canWrite"/>

    <div v-if="storing" class="col-8 mt-3 text-center">
      Die Daten werden gespeichert...
    </div>
    <div v-if="storedData" class="col-8 mt-3 text-right">
      <img class="opened" src="@/assets/images/icon-done.svg"/>
      gespeichert
    </div>
    <!--button @click="storeWorkflowData" class="mt-5 mb-3" type="button">Speichern</button-->
    <button v-show="canWrite" @click="finishWorkflowStep" type="button" class="done" :disabled="storing">Abschluss</button>

  </div>
</template>

<script>
import {inject} from 'vue'
import WorkflowNotes from "@/components/WorkflowNotes.vue";
import dayjs from "dayjs";
import DateInput from "@/components/form/DateInput.vue";
import TimeInput from "@/components/form/TimeInput.vue";

export default {
  name: "WorkflowCleaning",
  components: {TimeInput, DateInput, WorkflowNotes},
  data() {
    return {
      workflowStep: 40,
      actionDate: null,
      actionTime: null,
      systemCleaned: false,
      noteData: {
        text: '',
        images: null,
      },
      storedData: false,
      globalFunctions: inject('globalFunctions'),
      storing: false,
    }
  },
  props: {
    batch: {
      type: Object,
      required: true
    },
    canWrite: {
      type: Boolean,
      required: true
    },
  },
  created() {
    // const batch = this.$props.batch

    this.setActionDateTime()
    console.log('created', this.actionDate, this.actionTime)
  },
  methods: {
    async storeWorkflowData() {
      this.storing = true
      this.storedData = false

      const data = this.getFormData()
      const response = await this.$store.dispatch('uploadItem',
          {name: 'batch', id: this.batch.batchId, data})

      if (response && response.success) {
        this.storedData = true
      }
    },
    async finishWorkflowStep() {
      await this.storeWorkflowData()

      const data = {
        finishWorkflowStep: this.workflowStep,
      }
      const response = await this.$store.dispatch('cruItem',
          {name: 'batch', id: this.batch.batchId, data})

      this.storing = false
      if (response && response.success) {
        const data = this.getFormData()

        this.$emit('finishedWorkflowStep', { data: {
            ...data,
            workflowState: response.workflowState,
          }});
      }
    },
    getFormData() {
      return {
        workflowStep: this.workflowStep,
        actionDate: this.actionDate,
        actionTime: this.actionTime,
        systemCleaned: this.systemCleaned,
        noteText: this.noteData.text,
        noteImages: this.noteData.images,
      }
    },
    saveForm() {
    },
    setActionDateTime() {
      if (!this.actiontDate) this.actiontDate = dayjs().format('DD.MM.YYYY')
      if (!this.actiontTime) this.actiontTime = dayjs().format('HH:mm')
    },
  }
}
</script>